import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Collapse } from '@mui/material';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

function PersonalRetirementAccountLayout({ classes }) {
  const { resource } = useMetaLayoutContext();

  return (
    <div className={classes.root}>
      <MetaField attr="ownerClientId" className={classes.alignLeft} />
      <div className={classes.row}>
        <MetaField attr={'currentYearContributions'} />
        <MetaField attr={'currentYearContributionsAsOf'} />
      </div>
      <div className={classes.row}>
        <MetaField
          attr="facetModel"
          hidden={resource.attr('isManaged') === 'false'}
        />
        <MetaField
          attr="allocationType"
        />
      </div>
      <div className={classes.row}>
        <MetaField attr="decedent" />
        <MetaField attr="dateOfDeath" />
      </div>
      <MetaField attr="hasBeneficiary" />
      <Collapse in={resource.attr('hasBeneficiary') === 'true'}>
        <Box>
          <MetaField
            attr="relationship"
            hidden={resource.attr('hasBeneficiary') === 'false'}
          />
          <MetaField
            attr="primaryBeneficiary"
            hidden={resource.attr('hasBeneficiary') === 'false'}
          />
          <MetaField
            attr="contingentBeneficiary"
            hidden={resource.attr('hasBeneficiary') === 'false'}
          />
        </Box>
      </Collapse>
    </div>
  );
}

PersonalRetirementAccountLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  alignLeft: {
    textAlign: 'left',
  },
})(PersonalRetirementAccountLayout);
